import dateFns from 'date-fns'

import AppBtnSkew from '../app-btn-skew'
import AppBtn from '../app-btn'
import AppBtnSkewLink from '../app-btn-skew-link'


export default
{
    name: 'app-matches-table-counter',

    components:
    {
        AppBtn,
        AppBtnSkew,
        AppBtnSkewLink
    },

    props:
    {
        match: {type: Object},
        contentGlobal: {type: Object}
    },

    data()
    {
        return {
            status: 'is-today',
            isLive: false
        }
    },

    created()
    {
        this._now = Math.round(Date.now() / 1000)
        this.status = this._getStatus()
        this.isLive = this._now >= this.match.dateStart && this.match.status === 'pending'
    },

    methods:
    {
        _getStatus()
        {
            if (this._now >= this.match.dateStart && this.match.status !== 'pending')
            {
                return 'is-past'
            }
            else if (dateFns.isSameDay(this.match.dateStart * 1000, this._now * 1000))
            {
                return 'is-today'
            }

            return 'is-upcoming'
        },

        _scoreIsSuperior(one, two)
        {
            return one - two
        },

        _getBegins()
        {
            const daysDiff = dateFns.differenceInCalendarDays(this.match.dateStart * 1000, this._now * 1000)
            let diff
            
            if (daysDiff > 1)
            {
                diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.days
            }
            else if (daysDiff > 0)
            {
                diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.day
            }
            else
            {
                diff = dateFns.format(this.match.dateStart * 1000, 'h[:]mm[<sup>]a[</sup>]')
            }

            return diff
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-matches-table-counter/script.js